"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8039],{

/***/ 66610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28889);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);







var GameIcon = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? 40 : _size, src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "Icon" : _alt, blurDataURL = _param.blurDataURL, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 12 : _borderRadius, _mr = _param.mr, mr = _mr === void 0 ? 2 : _mr, imagesAboveFold = _param.imagesAboveFold, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "size",
        "src",
        "alt",
        "blurDataURL",
        "borderRadius",
        "mr",
        "imagesAboveFold"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        borderRadius: borderRadius,
        mr: mr,
        overflow: "hidden",
        flexShrink: 0,
        width: size,
        height: size,
        position: "relative"
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            layout: "fill",
            src: src,
            objectFit: "cover",
            alt: alt,
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            priority: imagesAboveFold
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (GameIcon);


/***/ }),

/***/ 80256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52543);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22318);

var GradientTypography = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    root: {
        background: "-webkit-linear-gradient(0, #D331FB 0%, #37BAFC 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontSize: "inherit",
        fontWeight: "inherit"
    }
})(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (GradientTypography);


/***/ }),

/***/ 20205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function SvgBack(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "Back_svg__a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 0h25v25H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#Back_svg__a)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M23 11.75H7.787l6.988-6.988L13 3 3 13l10 10 1.762-1.762-6.975-6.988H23z",
                    fill: "currentColor"
                })
            })
        ]
    }));
}
var MemoSvgBack = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(SvgBack);
/* harmony default export */ __webpack_exports__["Z"] = (MemoSvgBack);


/***/ }),

/***/ 18039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NavigationLayout_NavigationLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/api/definitions/game.definitions.ts
var game_definitions = __webpack_require__(45362);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/BottomNavigationAction/BottomNavigationAction.js
var BottomNavigationAction = __webpack_require__(48665);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/BottomNavigation/BottomNavigation.js
var BottomNavigation = __webpack_require__(25881);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/components/@common/GradientTypography/GradientTypography.tsx
var GradientTypography = __webpack_require__(80256);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/@icons/Discover1.tsx




function SvgDiscover1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Discover_1_svg__b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            transform: "translate(111 3106)",
                            fill: "#7a7a97",
                            stroke: "#707070",
                            d: "M0 0h20v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Discover_1_svg__a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h25v25H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Discover_1_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-108 -3103)",
                    clipPath: "url(#Discover_1_svg__b)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#7a7a97",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M119.339 3126h-7.47l-.87-.87v-7.47l.87-.87h7.47l.87.87v7.469zm-6.6-1.739h5.73v-5.732h-5.73zM130.129 3126h-7.47l-.87-.87v-7.47l.87-.87h7.47l.87.87v7.469zm-6.6-1.739h5.73v-5.732h-5.73zM119.339 3115.208h-7.47l-.87-.87v-7.469l.87-.87h7.47l.87.87v7.47zm-6.6-1.739h5.73v-5.73h-5.73zM130.129 3115.208h-7.47l-.87-.87v-7.469l.87-.87h7.47l.87.87v7.47zm-6.6-1.739h5.73v-5.73h-5.73z"
                        })
                    })
                })
            })
        ]
    }));
}
var MemoSvgDiscover1 = /*#__PURE__*/ react.memo(SvgDiscover1);
/* harmony default export */ var Discover1 = (MemoSvgDiscover1);

;// CONCATENATED MODULE: ./src/components/@icons/Discover2.tsx




function SvgDiscover2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Discover_2_svg__c",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            transform: "translate(111 3003)",
                            stroke: "#707070",
                            fill: "url(#Discover_2_svg__a)",
                            d: "M0 0h20v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Discover_2_svg__b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h25v25H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "Discover_2_svg__a",
                        x1: 0.297,
                        y1: 1.037,
                        x2: 0.656,
                        y2: 0.194,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#d331fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#37bafc"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Discover_2_svg__b)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-108 -3000)",
                    clipPath: "url(#Discover_2_svg__c)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M-4534.985-17743l-1.182-1.182v-6.8l1.182-1.186h6.8l1.181 1.186v6.8l-1.181 1.182zm1.195-2.371h4.413v-4.418h-4.413zm-12.028 2.371l-1.181-1.182v-6.8l1.181-1.186h6.8l1.182 1.186v6.8l-1.182 1.182zm1.195-2.371h4.414v-4.418h-4.414zm9.638-8.461l-1.182-1.182v-6.8l1.182-1.186h6.8l1.181 1.186v6.8l-1.181 1.182zm1.195-2.377h4.413v-4.414h-4.413zm-12.028 2.377l-1.181-1.182v-6.8l1.181-1.186h6.8l1.182 1.186v6.8l-1.182 1.182zm1.195-2.377h4.414v-4.414h-4.414z",
                        transform: "translate(4658 20766)",
                        fill: "url(#Discover_2_svg__a)"
                    })
                })
            })
        ]
    }));
}
var MemoSvgDiscover2 = /*#__PURE__*/ react.memo(SvgDiscover2);
/* harmony default export */ var Discover2 = (MemoSvgDiscover2);

;// CONCATENATED MODULE: ./src/components/@icons/AccountBalanceWallet1.tsx




function SvgAccountBalanceWallet1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fill: "none",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 00-2 2v8a2 2 0 002 2zm-9-2h10V8H12zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
            fill: "#7A7A97"
        })
    }));
}
var MemoSvgAccountBalanceWallet1 = /*#__PURE__*/ react.memo(SvgAccountBalanceWallet1);
/* harmony default export */ var AccountBalanceWallet1 = (MemoSvgAccountBalanceWallet1);

;// CONCATENATED MODULE: ./src/components/@icons/AccountBalanceWallet2.tsx




function SvgAccountBalanceWallet2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 00-2 2v8a2 2 0 002 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
                fill: "url(#account-balance-wallet_2_svg__paint0_linear_3937_45901)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "account-balance-wallet_2_svg__paint0_linear_3937_45901",
                    x1: 3,
                    y1: 12,
                    x2: 22,
                    y2: 12,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#D331FB"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#37BAFC"
                        })
                    ]
                })
            })
        ]
    }));
}
var MemoSvgAccountBalanceWallet2 = /*#__PURE__*/ react.memo(SvgAccountBalanceWallet2);
/* harmony default export */ var AccountBalanceWallet2 = (MemoSvgAccountBalanceWallet2);

;// CONCATENATED MODULE: ./src/components/@icons/Favourites1.tsx




function SvgFavourites1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Favourites_1_svg__b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            transform: "translate(186 3106)",
                            fill: "#7a7a97",
                            stroke: "#707070",
                            d: "M0 0h20v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Favourites_1_svg__a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h25v25H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Favourites_1_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-183 -3103)",
                    clipPath: "url(#Favourites_1_svg__b)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M196.628 3125.014h-1.253l-7.673-7.83a6.09 6.09 0 010-8.447 5.394 5.394 0 011.12-.87 5.785 5.785 0 017.177.87l.174-.174a5.785 5.785 0 018.125.183 6.09 6.09 0 010 8.439zm-4.776-16.338a3.984 3.984 0 00-2.114.6 3.645 3.645 0 00-.783.626 4.35 4.35 0 000 6.029l7.047 7.229 7.055-7.238a4.35 4.35 0 000-6.02 4.045 4.045 0 00-5.672-.13 4.124 4.124 0 00-.635.774h-1.479a4.01 4.01 0 00-3.419-1.87z",
                        fill: "#7a7a97"
                    })
                })
            })
        ]
    }));
}
var MemoSvgFavourites1 = /*#__PURE__*/ react.memo(SvgFavourites1);
/* harmony default export */ var Favourites1 = (MemoSvgFavourites1);

;// CONCATENATED MODULE: ./src/components/@icons/Favourites2.tsx




function SvgFavourites2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Favourites_2_svg__c",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h20v20H0z",
                            transform: "translate(186 3106)",
                            fill: "url(#Favourites_2_svg__a)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Favourites_2_svg__b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h25v25H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "Favourites_2_svg__a",
                        x1: 0.285,
                        y1: 0.881,
                        x2: 0.932,
                        y2: 0.094,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#d331fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.1,
                                stopColor: "#c33efb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#b34cfb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.3,
                                stopColor: "#a459fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#9467fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#8575fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#7583fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#6590fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#569efb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#46acfb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#36bafb"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Favourites_2_svg__b)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-183 -3103)",
                    clipPath: "url(#Favourites_2_svg__c)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        transform: "translate(185.489 3106.69)",
                        fill: "url(#Favourites_2_svg__a)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M11.108 17.88H9.917l-7.295-7.443a5.792 5.792 0 010-8.034 5.13 5.13 0 011.064-.823 5.5 5.5 0 016.826.827l.165-.165a5.5 5.5 0 017.728.174 5.792 5.792 0 010 8.026zM6.566 2.345a3.79 3.79 0 00-2.011.571 3.467 3.467 0 00-.745.6 4.137 4.137 0 000 5.734l6.7 6.876 6.71-6.884a4.137 4.137 0 000-5.726 3.847 3.847 0 00-5.395-.124 3.922 3.922 0 00-.6.736H9.822a3.814 3.814 0 00-3.256-1.783z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M11.322 18.38H9.707l-7.445-7.6a6.292 6.292 0 010-8.731 5.631 5.631 0 011.166-.9 6 6 0 017.081.568 6 6 0 018.255.349 6.292 6.292 0 010 8.72zm-1.191-1h.771l7.151-7.3a5.292 5.292 0 000-7.33 5 5 0 00-7.031-.154l-.517.517-.354-.361A5 5 0 003.95 2l-.012.007a4.631 4.631 0 00-.961.745 5.292 5.292 0 000 7.338zm.386-.546l-7.06-7.243a4.637 4.637 0 010-6.429 3.959 3.959 0 01.845-.677 4.286 4.286 0 012.26-.644h.03a4.29 4.29 0 013.491 1.779h.877a4.427 4.427 0 01.523-.6 4.347 4.347 0 016.1.138 4.627 4.627 0 010 6.42zM6.556 2.845a3.287 3.287 0 00-1.736.5l-.008.005a2.967 2.967 0 00-.637.51 3.628 3.628 0 000 5.044l6.342 6.506 6.352-6.517a3.628 3.628 0 000-5.031 3.347 3.347 0 00-4.691-.106 3.418 3.418 0 00-.524.64l-.147.232H9.542l-.147-.238a3.3 3.3 0 00-2.8-1.546z"
                            })
                        ]
                    })
                })
            })
        ]
    }));
}
var MemoSvgFavourites2 = /*#__PURE__*/ react.memo(SvgFavourites2);
/* harmony default export */ var Favourites2 = (MemoSvgFavourites2);

;// CONCATENATED MODULE: ./src/components/@icons/Friends1.tsx




function SvgFriends1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Friends_1_svg__b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            transform: "translate(261 3106)",
                            fill: "#7a7a97",
                            stroke: "#707070",
                            d: "M0 0h20v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Friends_1_svg__a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h25v25H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Friends_1_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    transform: "translate(-258 -3103)",
                    clipPath: "url(#Friends_1_svg__b)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#7a7a97",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M268.522 3116.047a5.024 5.024 0 115.02-5.023 5.024 5.024 0 01-5.02 5.023zm0-8.3a3.286 3.286 0 103.277 3.277 3.286 3.286 0 00-3.277-3.277zM268.527 3126a19.217 19.217 0 01-4.615-.556l-2.238-.548-.622-1.068 1.443-4.954.7-.617 1.895-.269a23.607 23.607 0 016.867 0l1.669.252.7.582 1.648 4.936-.617 1.139-2.234.548a19.122 19.122 0 01-4.6.556zm-5.553-2.608l1.356.33a17.81 17.81 0 008.4 0l1.312-.322-1.191-3.538-1.147-.174a21.677 21.677 0 00-6.362 0l-1.33.191zM279.314 3116.205l-.339-.461a12.7 12.7 0 00-1.6-.869 4.346 4.346 0 001.147-3.094 4.659 4.659 0 00-4.442-4.659l-.087 1.738a2.929 2.929 0 012.79 2.929 2.295 2.295 0 01-2.373 2.608l.087 1.738h1.017a5.867 5.867 0 012.225.965l1.3 4.294-.643.174.435 1.591 1.5-.409.608-1.1z"
                        })
                    })
                })
            })
        ]
    }));
}
var MemoSvgFriends1 = /*#__PURE__*/ react.memo(SvgFriends1);
/* harmony default export */ var Friends1 = (MemoSvgFriends1);

;// CONCATENATED MODULE: ./src/components/@icons/Friends2.tsx




function SvgFriends2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "Friends_2_svg__b",
                        y1: 1,
                        x2: 0.864,
                        y2: 0.056,
                        gradientUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0,
                                stopColor: "#d331fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.1,
                                stopColor: "#c33efb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#b34cfb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.3,
                                stopColor: "#a459fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#9467fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#8575fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#7583fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#6590fb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#569efb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.9,
                                stopColor: "#46acfb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#36bafb"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "Friends_2_svg__a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0 0h25v25H0z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Friends_2_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.042 19.385l-2.311-.624L0 17.5l1.461-5.53.825-.745 1.936-.31a20.861 20.861 0 016.761.024l1.724.286.807.707 1.686 5.523-.722 1.3-2.317.626A15.486 15.486 0 017.862 20a19.6 19.6 0 01-4.82-.615zM4.6 13.291l-1.045.167-.882 3.335.994.269a15.086 15.086 0 007.861 0l.951-.257-1.019-3.347-.876-.146a18.6 18.6 0 00-5.984-.021zm10.563 2.125l2.112-.571-1.016-3.345a14.4 14.4 0 00-3.938-.559L12.2 8.673l.4-.021A2.7 2.7 0 0015.189 5.9c0-1.958-1.156-2.71-2.236-2.761l-.4-.022.02-.41h-.019l.076-1.6h.019l.019-.387.4.019a4.5 4.5 0 013.313 1.6A5.513 5.513 0 0117.6 5.9a5.178 5.178 0 01-1.1 3.2l1.01.168.806.707 1.676 5.525-.722 1.3-3.478.94zM2.4 5.2a5.2 5.2 0 115.2 5.2 5.206 5.206 0 01-5.2-5.2zm2.407 0A2.794 2.794 0 107.6 2.406 2.8 2.8 0 004.807 5.2z",
                    transform: "translate(3 3)",
                    fill: "url(#Friends_2_svg__b)"
                })
            })
        ]
    }));
}
var MemoSvgFriends2 = /*#__PURE__*/ react.memo(SvgFriends2);
/* harmony default export */ var Friends2 = (MemoSvgFriends2);

// EXTERNAL MODULE: ./src/components/@navigation/Link/Link.tsx
var Link = __webpack_require__(18780);
;// CONCATENATED MODULE: ./src/components/@navigation/BottomNavigation/BottomNavigation.tsx











var items = [
    {
        label: "navigation.bottom.home",
        value: routes/* Routes.home */.Z.home,
        href: routes/* Routes.home */.Z.home,
        Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Discover1, {
            width: 24,
            height: 24
        }),
        IconGradient: /*#__PURE__*/ (0,jsx_runtime.jsx)(Discover2, {
            width: 24,
            height: 24
        })
    },
    {
        label: "navigation.bottom.subscription",
        value: routes/* Routes.subscriptions */.Z.subscriptions,
        href: routes/* Routes.subscriptions */.Z.subscriptions,
        Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountBalanceWallet1, {
            width: 24,
            height: 24
        }),
        IconGradient: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountBalanceWallet2, {
            width: 24,
            height: 24
        })
    },
    {
        label: "navigation.bottom.favorites",
        value: routes/* Routes.favorites */.Z.favorites,
        href: routes/* Routes.favorites */.Z.favorites,
        Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Favourites1, {
            width: 24,
            height: 24
        }),
        IconGradient: /*#__PURE__*/ (0,jsx_runtime.jsx)(Favourites2, {
            width: 24,
            height: 24
        })
    },
    {
        label: "navigation.bottom.friends",
        value: routes/* Routes.friends */.Z.friends,
        href: routes/* Routes.friends */.Z.friends,
        Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Friends1, {
            width: 24,
            height: 24
        }),
        IconGradient: /*#__PURE__*/ (0,jsx_runtime.jsx)(Friends2, {
            width: 24,
            height: 24
        })
    }, 
];
var SimpleBottomNavigation = function(param) {
    var currentPath = param.currentPath;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(currentPath), 2), value = ref[0], setValue = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    (0,react.useEffect)(function() {
        if (currentPath !== value) setValue(currentPath);
    }, [
        currentPath,
        value
    ]);
    var menuItems = (0,react.useMemo)(function() {
        if (currentPath.includes(routes/* Routes.collectionBottomNavigation */.Z.collectionBottomNavigation)) {
            return items.filter(function(item) {
                return item.value !== routes/* Routes.discover */.Z.discover;
            });
        } else {
            return items.filter(function(item) {
                return item.value !== routes/* Routes.collectionBottomNavigation */.Z.collectionBottomNavigation;
            });
        }
    }, [
        currentPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
        component: "nav",
        style: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0
        },
        elevation: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomNavigation/* default */.Z, {
            value: value,
            onChange: function(_event, newValue) {
                setValue(newValue);
            },
            showLabels: true,
            children: menuItems.map(function(item, idx) {
                var isActive = value === item.value;
                var label = intl.formatMessage({
                    id: item.label
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomNavigationAction/* default */.Z, {
                    component: Link/* default */.C,
                    href: item.href,
                    label: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientTypography/* default */.Z, {
                        children: label
                    }) : label,
                    icon: isActive ? item.IconGradient : item.Icon,
                    value: item.value
                }, idx);
            })
        })
    });
};
/* harmony default export */ var BottomNavigation_BottomNavigation = (SimpleBottomNavigation);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Icon/Icon.js
var Icon = __webpack_require__(92863);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(89039);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/hooks/useBackRouter.ts
var useBackRouter = __webpack_require__(28775);
// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(22291);
// EXTERNAL MODULE: ./src/hooks/mounted/useMounted.ts
var useMounted = __webpack_require__(18063);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/components/@common/GameIcon/GameIcon.tsx
var GameIcon = __webpack_require__(66610);
;// CONCATENATED MODULE: ./src/components/@icons/Close.tsx




function SvgClose(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "Close_svg__a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0h25v25H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Close_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23 5.014L20.986 3 13 10.986 5.014 3 3 5.014 10.986 13 3 20.986 5.014 23 13 15.014 20.986 23 23 20.986 15.014 13z",
                    fill: "currentColor"
                })
            })
        ]
    }));
}
var MemoSvgClose = /*#__PURE__*/ react.memo(SvgClose);
/* harmony default export */ var Close = (MemoSvgClose);

;// CONCATENATED MODULE: ./src/components/@icons/Menu.tsx




function SvgMenu(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "Menu_svg__a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0h25v25H0z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#Menu_svg__a)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    transform: "translate(-20 -27)",
                    fill: "currentColor",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: 25,
                            height: 3,
                            rx: 1.5,
                            transform: "translate(20 30)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: 25,
                            height: 3,
                            rx: 1.5,
                            transform: "translate(20 38.5)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: 25,
                            height: 3,
                            rx: 1.5,
                            transform: "translate(20 47)"
                        })
                    ]
                })
            })
        ]
    }));
}
var MemoSvgMenu = /*#__PURE__*/ react.memo(SvgMenu);
/* harmony default export */ var Menu = (MemoSvgMenu);

// EXTERNAL MODULE: ./src/components/@icons/Back.tsx
var Back = __webpack_require__(20205);
// EXTERNAL MODULE: ./src/components/@navigation/ElevationScroll/ElevationScroll.tsx
var ElevationScroll = __webpack_require__(47501);
;// CONCATENATED MODULE: ./src/components/@navigation/Header/Header.tsx















var MenuDrawer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8376), __webpack_require__.e(8498)]).then(__webpack_require__.bind(__webpack_require__, 8498));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8498)
            ];
        }
    }
});
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        title: {
            fontWeight: "unset",
            flexGrow: 1,
            textAlign: "center"
        },
        menuButton: {
            marginRight: theme.spacing(2),
            color: theme.palette.text.primary
        },
        language: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            lineHeight: 1,
            textTransform: "uppercase"
        },
        button: {
            marginTop: theme.spacing(5)
        },
        backButton: {
            color: theme.palette.text.primary,
            marginLeft: -4
        }
    };
});
var Header = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, appBarPosition = param.appBarPosition, backAction = param.backAction;
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var router = (0,useBackRouter/* useBackRouter */.k)();
    var classes = useStyles();
    var ref1 = (0,useAuth/* useAuth */.a)(), isLoggedIn = ref1.isLoggedIn, user = ref1.user;
    var isMounted = (0,useMounted/* default */.Z)();
    var handleIconClick = function() {
        setIsMenuOpen(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            variant === "default" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawer, {
                open: isMenuOpen,
                onClose: function() {
                    return setIsMenuOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ElevationScroll/* default */.Z, {
                isMenuOpen: isMenuOpen,
                disabled: appBarPosition === "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                    position: appBarPosition,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                        variant: "dense",
                        children: [
                            variant === "default" && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                className: classes.menuButton,
                                edge: "start",
                                onClick: handleIconClick,
                                "aria-label": "menu",
                                size: "small",
                                children: isMenuOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {})
                            }),
                            variant === "backbutton" && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                edge: "start",
                                "aria-label": "back",
                                color: "inherit",
                                onClick: backAction ? backAction : function() {
                                    return router.back();
                                },
                                className: classes.backButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Back/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.C, {
                                    href: routes/* Routes.home */.Z.home,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        priority: true,
                                        src: "/branding/img-logo-gamenation.svg",
                                        alt: "game nation logo",
                                        height: 27,
                                        width: 97
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: 32,
                                children: !isMounted && !isLoggedIn || !user && isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 32,
                                    height: 32,
                                    variant: "circle"
                                }) : isLoggedIn && user && user.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.C, {
                                    href: routes/* Routes.profile */.Z.profile,
                                    "aria-label": "view settings",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameIcon/* default */.Z, {
                                        src: user.avatar,
                                        alt: user.username,
                                        size: 32,
                                        borderRadius: "50%",
                                        imagesAboveFold: true
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.C, {
                                    href: routes/* Routes.language */.Z.language,
                                    color: "textSecondary",
                                    underline: "hover",
                                    className: classes.language,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "language.shortcode.".concat(router.locale)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDropDown/* default */.Z, {})
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./src/components/@layout/NavigationLayout/NavigationLayout.tsx







var NavigationLayout = function(param) {
    var children = param.children, _headerVariant = param.headerVariant, headerVariant = _headerVariant === void 0 ? "default" : _headerVariant, gameType = param.gameType, _behaviour = param.behaviour, behaviour = _behaviour === void 0 ? "scroll" : _behaviour, _hideBottomNavigation = param.hideBottomNavigation, hideBottomNavigation = _hideBottomNavigation === void 0 ? false : _hideBottomNavigation, backAction = param.backAction;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        children: [
            headerVariant !== "none" && (!gameType || gameType === game_definitions/* GameType.firstParty */.D$.firstParty) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                        variant: gameType === game_definitions/* GameType.firstParty */.D$.firstParty ? "backbutton" : headerVariant,
                        appBarPosition: behaviour === "fixed" ? "relative" : undefined,
                        backAction: backAction
                    }),
                    behaviour !== "fixed" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        height: 56,
                        flexShrink: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        flex: 1,
                        children: children
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                flex: 1,
                children: children
            }),
            !hideBottomNavigation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        height: 56,
                        flexShrink: 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomNavigation_BottomNavigation, {
                        currentPath: router.pathname
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NavigationLayout_NavigationLayout = (NavigationLayout);


/***/ }),

/***/ 47501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ElevationScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57369);


function ElevationScroll(props) {
    var children = props.children, isMenuOpen = props.isMenuOpen, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var trigger = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        disableHysteresis: true,
        threshold: 0
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        elevation: trigger && !disabled ? 2 : 0,
        style: {
            backgroundColor: disabled || trigger || isMenuOpen ? undefined : "transparent",
            transition: disabled || trigger || isMenuOpen ? "none" : "background-color 500ms ease-in"
        }
    });
}


/***/ }),

/***/ 28775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useBackRouter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68711);
/* harmony import */ var services_router_RouterProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63299);






var useBackRouter = function() {
    var fallbackRoute = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : routes__WEBPACK_IMPORTED_MODULE_2__/* .Routes.home */ .Z.home;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var prevRoute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(services_router_RouterProvider__WEBPACK_IMPORTED_MODULE_3__/* .RouterContext */ ._);
    var back = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        if (prevRoute) {
            router.back();
        } else {
            router.replace(fallbackRoute);
        }
    }, [
        fallbackRoute,
        prevRoute,
        router
    ]);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router), {
        back: back
    });
};


/***/ }),

/***/ 45362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D$": function() { return /* binding */ GameType; },
/* harmony export */   "Qe": function() { return /* binding */ SubscriptionType; },
/* harmony export */   "Ui": function() { return /* binding */ GameProvider; },
/* harmony export */   "f2": function() { return /* binding */ TypeOfGame; },
/* harmony export */   "zc": function() { return /* binding */ ContentType; }
/* harmony export */ });
var GameProvider;
(function(GameProvider) {
    GameProvider["Newcom"] = "Newcom";
    GameProvider["Gameloft"] = "Gameloft";
    GameProvider["Nazara"] = "Nazara";
})(GameProvider || (GameProvider = {}));
var ContentType;
(function(ContentType) {
    ContentType["game"] = "game";
    ContentType["subscription"] = "subscription";
})(ContentType || (ContentType = {}));
var TypeOfGame;
(function(TypeOfGame) {
    TypeOfGame["scratch"] = "scratch";
    TypeOfGame["token"] = "token";
    TypeOfGame["quiz"] = "quiz";
    TypeOfGame["raffle"] = "raffle";
    TypeOfGame["vote"] = "vote";
    TypeOfGame["webview"] = "webview";
    TypeOfGame["slot"] = "slot";
    TypeOfGame["wheel"] = "wheel";
})(TypeOfGame || (TypeOfGame = {}));
var GameType;
(function(GameType) {
    GameType["firstParty"] = "FirstParty";
    GameType["thirdParty"] = "ThirdParty";
    GameType["service"] = "Service";
})(GameType || (GameType = {}));
var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType["perGameSession"] = "PerGameSession";
    SubscriptionType["oneTimePurchase"] = "OneTimePurchase";
    SubscriptionType["inGamePurchases"] = "InGamePurchases";
    SubscriptionType["perMessage"] = "PerMessage";
})(SubscriptionType || (SubscriptionType = {}));


/***/ })

}]);